import { BaseModel } from "sjs-base-model";
import { formatDate } from "../../utilities/TimeUtility";

 export default class ApiKeyModel extends BaseModel{
    
    public apiId: string = '';
    public userId: string = '';
    public key: string | undefined= '';
    public createDate: string = '';
    public expiryDate: string = ''; 
   
    
    constructor(data: Partial<ApiKeyModel>) {
      super();
      this.update({
        apiId: data.apiId,
        userId: data.userId,
        key: data.key || '',
        createDate: formatDate(data.createDate || ''),
        expiryDate: formatDate(data.expiryDate || ''),
    }); 
  }
}


